<div [style.right.%]="windowRight" class="d-flex flex-column mh-75 global-popup-window end-25 cursor-auto bottom-0 position-fixed bg-white" [ngClass]="{'maximize-style':maximize,'minimize-style bg-primary overflow-hidden':!maximize}">
  <div class="" [style.height]="!maximize? '0': ''">
    <ng-container *ngIf="template"
                  [ngTemplateOutlet]="template" class="row content">
    </ng-container>
  </div>
</div>
